import React, { useCallback } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { setSnackbarNotify } from 'redux/slices/modals/modals.slice';
import { selectSnackbarNotify } from 'redux/selectors/selectors';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export const NotifySnackbar = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectSnackbarNotify);

  const handleClose = useCallback(
    (_event?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === 'clickaway') return;
      dispatch(setSnackbarNotify({ open: false }));
    },
    [dispatch],
  );

  const iconSize = { md: 'calc(50px / 1.5)', sm: 'calc(50px / 2)', xs: 'calc(50px / 2)' };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={state?.open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={15000}
        sx={{
          bottom: { md: 8, sm: 90, xs: 90 },
          right: { md: 22, sm: 8, xs: 8 },
          left: 8,
        }}
      >
        <Alert
          onClose={handleClose}
          severity={state?.severity || 'info'}
          variant="standard"
          sx={{
            maxWidth: 'calc(600px / 1.5)',
            minHeight: 'calc(170px / 1.5)',
            padding: { md: '32px 20px', sm: '20px', xs: '20px' },
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            color: 'black',
            fontWeight: '700',
            fontSize: { md: 'calc(26px / 1.5)', sm: 'calc(26px / 1.7)', xs: 'calc(26px / 1.7)' },
            borderRadius: 'calc(12px / 1.5)',
            '& .MuiAlert-message': {
              padding: '8px 8px 8px 0',
            },
          }}
          iconMapping={{
            success: (
              <CheckCircleIcon
                sx={{
                  fontSize: iconSize,
                  color: 'info.dark',
                }}
              />
            ),
            error: (
              <CancelIcon
                sx={{
                  fontSize: iconSize,
                  color: 'error.main',
                }}
              />
            ),
            info: (
              <InfoRoundedIcon
                sx={{
                  fontSize: iconSize,
                  color: 'info.contrastText',
                }}
              />
            ),
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                top: 'calc(20px / 4)',
                right: 'calc(20px / 4)',
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: '25px',
                }}
              />
            </IconButton>
          }
        >
          {state?.message || 'Произошла ошибка'}
        </Alert>
      </Snackbar>
    </Stack>
  );
};
